module.exports = __webpack_public_path__ + "img/dab_toscania.91baefb2.jpg";